import React from 'react';
import Image from 'next/image';
import { useTranslations } from 'next-intl';

interface IProps {
  totalQuestions?: number;
  correctAnswersCount?: number;
  incorrectAnswers?: number;
}

const ResultStatistics: React.FC<IProps> = ({ correctAnswersCount, incorrectAnswers, totalQuestions }) => {
  const t = useTranslations();

  return (
    <div className="flex items-center justify-between rounded-xl bg-gray-100 py-2">
      <div className="flex w-full flex-col space-y-1 border-r-2 border-gray-300 text-center">
        <div className="flex items-center justify-center gap-1">
          <div className="size-4 relative">
            <Image src="/images/total-test-paper.webp" fill alt="Total tests count" title="Umumiy savollar soni" />
          </div>
          <p className="font-medium text-xs">{totalQuestions}</p>
        </div>
        <p className="text-[0.6rem] text-gray-400">{t('jami_test')}</p>
      </div>
      <div className="flex w-full flex-col space-y-1 border-r-2 border-gray-300 text-center">
        <div className="flex items-center justify-center gap-1">
          <div className="size-4 relative">
            <Image src="/images/correct-answer.webp" fill alt="Correct Answer" title="Tog'ri javob" />
          </div>
          <p className="font-medium text-xs">{correctAnswersCount}</p>
        </div>
        <p className="text-[0.6rem] text-gray-400">{t('togrilar')}</p>
      </div>
      <div className="flex w-full flex-col space-y-1 text-center">
        <div className="flex items-center justify-center gap-1">
          <div className="size-4 relative">
            <Image src="/images/incorrect-answer.webp" fill alt="Incorrect Answer" title="Notog'ri javob" />
          </div>
          <p className="font-medium text-xs">{incorrectAnswers}</p>
        </div>
        <p className="text-[0.6rem] text-gray-400">{t('xatolar')}</p>
      </div>
    </div>
  );
};

export default ResultStatistics;
